import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { normCat, CATEGORY_IMAGES, CATEGORY_ICONS, CATEGORY_COLORS } from './constants';

export const FamilyScrollMenu = ({ categories, loading }) => {
    if (loading) {
        return (
            <section className="py-12 bg-[#FAFAF5]" data-testid="family-scroll-section">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex gap-4 overflow-hidden">
                        {[1,2,3,4,5].map(i => (
                            <div key={i} className="flex-shrink-0 w-56 h-32 bg-gray-200 animate-pulse rounded-2xl" />
                        ))}
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="py-12 md:py-16 bg-[#FAFAF5]" data-testid="family-scroll-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between mb-8">
                    <div>
                        <p className="text-xs font-bold uppercase tracking-widest text-emerald-600 mb-2">Catalogue</p>
                        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 tracking-tight">
                            Nos Familles de Produits
                        </h2>
                    </div>
                    <Link
                        to="/catalogue"
                        className="hidden sm:flex items-center gap-2 text-sm font-medium text-emerald-600 hover:text-emerald-700 transition-colors"
                        data-testid="see-all-catalogue"
                    >
                        Voir tout
                        <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>

                <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-thin scrollbar-thumb-emerald-200 scrollbar-track-transparent -mx-4 px-4 snap-x snap-mandatory" data-testid="family-scroll-container">
                    {categories.map(cat => {
                        const catId = normCat(cat.id);
                        const image = CATEGORY_IMAGES[catId] || cat.image_url;
                        const icon = CATEGORY_ICONS[catId] || '';
                        const color = CATEGORY_COLORS[catId] || '#22C55E';

                        return (
                            <Link
                                key={cat.id}
                                to={`/catalogue?category=${catId}`}
                                className="group flex-shrink-0 snap-start relative overflow-hidden rounded-2xl w-[200px] sm:w-[240px] h-[160px] sm:h-[180px] shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                                data-testid={`family-scroll-${catId}`}
                            >
                                <img
                                    src={image}
                                    alt={cat.name}
                                    loading="lazy"
                                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                />
                                <div
                                    className="absolute inset-0"
                                    style={{
                                        background: `linear-gradient(to top, ${color}DD 0%, ${color}55 45%, transparent 75%)`,
                                    }}
                                />
                                <div className="absolute top-3 right-3 w-9 h-9 rounded-xl flex items-center justify-center text-lg backdrop-blur-sm bg-white/80">
                                    {icon}
                                </div>
                                <div className="absolute bottom-0 left-0 right-0 p-4">
                                    <h3 className="text-white font-bold text-base sm:text-lg drop-shadow-md">
                                        {cat.name}
                                    </h3>
                                    <div className="flex items-center gap-1 mt-1 text-white/90 text-xs font-medium group-hover:gap-2 transition-all">
                                        Voir les produits
                                        <ArrowRight className="w-3 h-3" />
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>

                <div className="sm:hidden mt-4 text-center">
                    <Link
                        to="/catalogue"
                        className="inline-flex items-center gap-2 text-sm font-medium text-emerald-600"
                    >
                        Voir tout le catalogue
                        <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>
            </div>
        </section>
    );
};
